export default "__VITE_ASSET__Dm88fcOX__"